module.exports = __webpack_public_path__ + "static/APPAREL2-18c0b8cc200e66170f340f2b2309cf0e.png";